import script from './AccordionItem.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion__item",class:{ 'acordion-item--unavailable': _vm.isDisabled },attrs:{"id":("item-" + _vm.uuid)}},[_c('div',{staticClass:"accordion__item-header",on:{"click":_vm.onClick}},[_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"accordion__item-header-control"},[_c('Icon',{class:_vm.iconClass})],1)],2),_vm._v(" "),(_vm.isOpen)?_c('div',{ref:"contentBox",staticClass:"accordion__item-content"},[_vm._t("content")],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
